<template>

    <div class="nl">

        <newsletters-v2-header v-show="isNoTuto"
                               :category="category"
                               :subscriptions="subscriptionsFromSelectedMailbox"
                               :maxSubscriptions="maxSubscriptions"
                               @updateCategory="updateCategory"
        ></newsletters-v2-header>

        <search v-show="showSearch"
                :list="sortedSubscriptions"
                :searchValue="searchValue"
        ></search>

        <multi-scan-completed v-if="isDesktop"></multi-scan-completed>

        <list v-if="showList"
              :list="sortedSubscriptions"
              :searching="searching"
              :category="category"
              @action="action"
        ></list>

        <cards v-if="showCards"
               ref="CARDS"
               :subscriptions="sortedSubscriptions"
               :category="category"
               @action="action"
               @share="share"
        ></cards>


        <senders v-if="showSenders"></senders>

        <multi-scan-completed v-if="!isDesktop"></multi-scan-completed>

        <tuto v-if="isTuto" @close="initPage"></tuto>

        <empty v-if="showEmpty"></empty>

        <terms-update></terms-update>

        <modal-tuto-action ref="modalTutoAction"
                           @close="closeModal"
        ></modal-tuto-action>

        <modal-share ref="MS"></modal-share>

        <modal-rating ref="MR"></modal-rating>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Api from '../api'

import ENUM from '../assets/ENUM'

import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import Cards from '../components/newsletters-v2/Cards'
import Empty from '../components/newsletters-v2/Empty'
import List from '../components/newsletters-v2/List'
import ModalRating from '../components/modal/ModalRating'
import ModalShare from '../components/modal/ModalShare'
import ModalTutoAction from '../components/modal/ModalTutoAction'
import MultiScanCompleted from '../components/newsletters-v2/MultiScanCompleted'
import NewslettersV2Header from '../components/newsletters-v2/Header'
import Search from '../components/newsletters-v2/Search'
import Senders from '../components/newsletters-v2/Senders'
import TermsUpdate from '../components/TermsUpdate'
import Tuto from '../components/newsletters-v2/tuto/Tuto'
import Storage from '../helpers/storage'
import Subscription from '../helpers/subscription'


export default {

    name: 'newsletters-v2',

    components: {
        Cards,
        Empty,
        List,
        ModalRating,
        ModalShare,
        ModalTutoAction,
        MultiScanCompleted,
        NewslettersV2Header,
        Search,
        Senders,
        TermsUpdate,
        Tuto
    },

    watch: {
        mailboxes: function () {
            this.updateMaxSubscriptions()
        },

        newslettersPage(newPage) {

            switch (newPage) {
                case ENUM.NEWSLETTERS.PAGE.LIST:
                    Tag.pageViewGA(this, 'cleaning_list')
                    UserFlow.setPage(this, 'cleaning_list')
                    break
                case ENUM.NEWSLETTERS.PAGE.CARDS:
                    Tag.pageViewGA(this, 'cleaning_cards')
                    UserFlow.setPage(this, 'cleaning_cards')
                    break
            }
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'mailboxes',
            'newsletters',
            'newslettersLoaded',
            'newslettersPage',
            'newslettersSearchingMode',
            'newslettersSort',
            'searchValue'
        ]),

        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        },

        isCards() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.CARDS && !this.showEmpty
        },

        isList() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.LIST && !this.showEmpty
        },

        isTuto() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.TUTO
        },

        subscriptionsFromSelectedMailbox() {
            const arraySelected = []
            for (const mailbox of this.mailboxes) {
                if (mailbox.isActive) {
                    arraySelected.push(mailbox.email)
                }
            }
            let subscriptions = [...this.newsletters.subscriptions]
            subscriptions = subscriptions.filter(subscription => arraySelected.indexOf(subscription.email) > -1)
            return subscriptions
        },

        categorisedSubscriptions() {
            switch (this.category) {
                case ENUM.NEWSLETTERS.CATEGORIES.ALL:
                    return this.subscriptionsFromSelectedMailbox
                case ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => !Subscription.isSpoum(subscription))
                case ENUM.NEWSLETTERS.CATEGORIES.SPAMS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => Subscription.isSpoum(subscription))
            }
        },

        filteredSubscriptions() {
            if (this.searching && this.searchValue === '') {
                return []
            } else {
                return this.searchValue
                    ? this.categorisedSubscriptions.filter(item => `${item.name} ${item.sender}`.indexOf(this.searchValue) > -1)
                    : this.categorisedSubscriptions
            }
        },

        sortedSubscriptions() {
            const newArray = JSON.parse(JSON.stringify(this.filteredSubscriptions || []))
            switch (this.newslettersSort) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.openRate, itemA.openRate))
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.openRate, itemB.openRate))
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.count, itemB.count))
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.count, itemA.count))
            }
            return newArray
        },

        isNoTuto() {
            return !this.isTuto
        },

        showEmpty() {
            return !this.isTuto
                && this.subscriptionsFromSelectedMailbox
                && this.subscriptionsFromSelectedMailbox.length === 0
                && this.newslettersLoaded
        },

        showList() {
            return (this.isDesktop ? true : this.newslettersSearchingMode !== ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING) && this.isList
        },

        showCards() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && this.isCards
        },

        showSenders() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING
        },

        showSearch () {
            return this.isNoTuto && (this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE || this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING)
        }

    },

    data() {
        return {
            extras: [],
            category: '',
            tempUnsubscribe: [],
            tempKeep: [],
            tempDelete: [],
            timeoutFunction: () => {
            },
            maxSubscriptions: 0,
            searching: false,
            rating: {
                actionCount: 0,
                shownAfter: 20,
                alreadyShown: false,
                opened: false,
                hasRated: false,
                displayCount: 0
            }
        }
    },

    mounted() {
        this.initPage()

        this.updateCategory(ENUM.NEWSLETTERS.CATEGORIES.ALL)

        this.initData()

    },

    methods: {

        ...Vuex.mapActions([
            'initNewsletterSort',
            'refreshNewsletters',
            'refreshUnfinishedMailboxes',
            'updateNewslettersPage',
            'updateSubscriptions'
        ]),

        initPage() {

            this.initNewsletterSort()

            const tutoDone = !Storage.getItem(Storage.KEYS.TUTO_NEWSLETTERS)
            if (tutoDone) {
                this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.TUTO)
            } else {

                const savedPage = Storage.getItem(Storage.KEYS.NEWSLETTERS_PAGE)
                if (savedPage && Object.values(ENUM.NEWSLETTERS.PAGE).includes(savedPage)) {
                    this.updateNewslettersPage(savedPage)
                    Storage.removeItem(Storage.KEYS.NEWSLETTERS_PAGE)
                } else {
                    this.isDesktop
                        ? this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.LIST)
                        : this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.CARDS)
                }
            }
        },

        initData() {
            this.refreshNewsletters(this.newslettersAsyncInitData)
                .then(response => {
                    this.updateMaxSubscriptions()

                    // If global fetch is done but all mailboxes are not done
                    if (response.mailboxes.filter(mailbox => !mailbox.done).length > 0) {
                        this.refreshUnfinishedMailboxes()
                    }
                })
        },

        newslettersAsyncInitData(data) {
            if (data.status !== ENUM.FETCH_STATUS.DONE) {
                this.$router.push({path: '/fetch'})
            }
        },

        updateMaxSubscriptions() {
            this.maxSubscriptions = this.subscriptionsFromSelectedMailbox
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS).length
        },

        updateCategory(newCategory) {
            this.category = newCategory
        },

        action({enumAction, senders}) {
            if (this.needConfirmation(enumAction)) {
                this.$refs.modalTutoAction.open(senders, enumAction)
            } else {
                this.requestAction({enumAction, senders})
            }
        },

        requestAction({enumAction, senders}) {
            this.removeFromSendersList(senders)

            const cleanedSenders = senders.filter(item => item.type !== ENUM.NEWSLETTERS.CARDS.SHARING
                && item.type !== ENUM.NEWSLETTERS.CARDS.MARKET
                && item.type !== ENUM.NEWSLETTERS.CARDS.GREENFOX)

            this.updateRating(cleanedSenders.length)

            this.waitBeforeSend({enumAction, senders: cleanedSenders})
        },

        removeFromSendersList(newslettersToRemove) {
            const newSubscriptions = this.newsletters.subscriptions.reduce((acc, subscriptionItem) => {
                // Search subscriptionItem in the newslettersToRemove
                if (!newslettersToRemove.find((removed) => {
                    return (removed.sender === subscriptionItem.sender && removed.email === subscriptionItem.email)
                })) {
                    // We can keep subscriptionItem because not in newslettersToRemove
                    acc.push(subscriptionItem)
                }
                return acc
            }, [])
            this.updateSubscriptions(newSubscriptions)
        },

        waitBeforeSend({enumAction, senders}) {

            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    this.tempUnsubscribe = [...this.tempUnsubscribe, ...senders]
                    break
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    this.tempKeep = [...this.tempKeep, ...senders]
                    break
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    this.tempDelete = [...this.tempDelete, ...senders]
                    break
            }

            this.restartCounter()
        },

        restartCounter() {
            this.clearCounter()
            this.startCounter()
        },

        startCounter() {
            this.timeoutFunction = setTimeout(() => {
                this.sendNewslettersRequest()
            }, this.firebaseTimeBeforeBatch)
        },

        clearCounter() {
            clearInterval(this.timeoutFunction)
        },

        sendNewslettersRequest() {
            if (this.tempUnsubscribe.length) {
                const senders = this.tempUnsubscribe
                Api.newsletters.unsubscribe(this.reduceActionInformations(this.tempUnsubscribe))
                    .catch(() => {
                        this.newslettersRequestError(senders)
                    })
                    .finally(() => {
                        this.tempUnsubscribe = []
                    })
            }
            if (this.tempDelete.length) {
                const senders = this.tempDelete
                Api.newsletters.delete(this.reduceActionInformations(this.tempDelete))
                    .catch(() => {
                        this.newslettersRequestError(senders)
                    })
                    .finally(() => {
                    })
            }
            if (this.tempKeep.length) {
                const senders = this.tempKeep
                Api.newsletters.keep(this.reduceActionInformations(this.tempKeep))
                    .catch(() => {
                        this.newslettersRequestError(senders)
                    })
                    .finally(() => {
                        this.tempKeep = []
                    })
            }
        },

        newslettersRequestError(array) {
            const newSubscriptions = [...this.newsletters.subscriptions, ...array]
            this.updateSubscriptions(newSubscriptions)
        },

        reduceActionInformations(newsletters) {
            return newsletters.map(newsletter => ({email: newsletter.email, sender: newsletter.sender}))
        },

        needConfirmation(enumAction) {
            if (this.isCards) {
                return false
            }
            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return !Storage.getItem('disableModalUnsubscribe')
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return !Storage.getItem('disableModalDelete')
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return !Storage.getItem('disableModalKeep')
            }
        },

        closeModal({accept, enumAction, senders}) {
            if (accept) {
                this.requestAction({enumAction, senders})
            } else if (this.isCards) {
                //refresh Cards if rollback after throw out
                this.$refs.CARDS.refresh()
            }
        },

        compare(itemA, itemB) {
            if (itemA < itemB) {
                return -1
            }
            if (itemA > itemB) {
                return 1
            }
            return 0
        },

        share() {
            this.$refs.MS.open()
        },

        updateRating(length) {

            this.rating.actionCount += length

            if (!this.rating.alreadyShown && this.rating.displayCount < 2) {
                if (!this.rating.opened) {
                    if (this.rating.actionCount >= this.rating.shownAfter) {
                        this.rating.displayCount += 1
                        this.rating.opened = true
                        this.rating.shownAfter = this.rating.actionCount + 40
                        this.$refs.MR.open()
                    }
                }
            }
        }
    },

    destroyed() {
        this.clearCounter()
    }
}
</script>

<style lang="scss" scoped>

.nl {
    background-color: $timberwolf;
    position: relative;

    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }
}

</style>
